import { render, staticRenderFns } from "./page-maintenance.vue?vue&type=template&id=5348a6dd&"
import script from "./page-maintenance.vue?vue&type=script&lang=js&"
export * from "./page-maintenance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports